import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import DevicesAndEquipmentsBlockData from 'Models/Content/DevicesAndEquipmentsBlockData';
import MainDevicesAndEquipments from './MainDevicesAndEquipments';
import './DevicesAndEquipments.scss';

export default class DevicesAndEquipmentsGeneralBlock extends EpiComponent<DevicesAndEquipmentsBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    return <MainDevicesAndEquipments iContent={this.props.data} context={this.getContext()} />;
  }
}

